import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import RenderIcons from "../../../Assets/css/_icons/partner_icon/RenderIcons";
import { ApplicationState } from "../../../store";
import { IPackage, IProduct } from "../../../store/protectionPlanService/ezs/types";
import { useTranslation } from "react-i18next";

interface IProps {
    closeDialog: any;
    showNextDialog: any;
    packageIndex: number;
}

const ProtectionPlanSubscriptionChangeDialog: React.FunctionComponent<IProps> = (props) => {
    const packageList = useSelector((state: ApplicationState) => {
        if (state.protectionPlanState && state.protectionPlanState.protectionPlanData) {
            return state.protectionPlanState.protectionPlanData.packageList;
        }
    });
    const selectedPackage = (packageList && packageList.length >= props.packageIndex ? packageList[props.packageIndex] : null) as IPackage;
    const { t: tLang } = useTranslation();

    const displayConfirmationMessage = () => {
        if (selectedPackage?.SubcriptionType?.toUpperCase() === "MONTHLY") {
            return <p>{tLang("manageAccount.protectionPlan.changePlanpopup.monthToYear")}</p>;
        } else if (selectedPackage?.SubcriptionType?.toUpperCase() === "YEARLY") {
            return <p>{tLang("manageAccount.protectionPlan.changePlanpopup.yearToMonth")}</p>;
        } else {
            return "";
        }
    };

    useEffect(() => {
        window.addEventListener("keyup", (evt: any) => {
            evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = evt.key === "Escape" || evt.key === "Esc";
            } else {
                isEscape = evt.keyCode === 27;
            }
            if (isEscape) {
                props.closeDialog();
            }
        });
        return () => {
            window.removeEventListener("keyup", () => {});
        };
    });

    return (
        <React.Fragment>
            <div className="dialog-header">
                <div className="dialog-icon">
                    <RenderIcons iconName="coins" />
                </div>
                <h1>{tLang("manageAccount.protectionPlan.changePlanpopup.title")}</h1>
            </div>

            <div className="dialog-body">{displayConfirmationMessage()}</div>

            <div className="dialog-footer">
                <div className="row between-xs">
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button
                            type="button"
                            className="btn-default btn-link btn-no-padding btn-no-border"
                            id="btn-cancel-subscription-change"
                            onClick={() => {
                                props.closeDialog();
                                window.addToDataLayer({ event: "Protection Plan - Close subscription type change" });
                            }}
                        >
                            <span className="btn-text">{tLang("manageAccount.protectionPlan.btn.cancel")}</span>
                        </button>
                    </div>
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button
                            type="button"
                            className="btn-default btn-primary"
                            id="btn-submit-subscription-change"
                            onClick={() => {
                                props.showNextDialog();
                                window.addToDataLayer({ event: "Protection Plan - " + selectedPackage?.ActionButtonText?.toUpperCase() });
                            }}
                        >
                            <span className="btn-text">{tLang("manageAccount.protectionPlan.btn.continue")}</span>
                        </button>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};
export default ProtectionPlanSubscriptionChangeDialog;
